import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthProvider';
import { LoadingState } from '../states/StateViews';
import { ErrorPage } from '../ErrorPage';
import type { Role } from '../../lib/roles';

// Guards a route by role. Guests -> /login; wrong role -> 403 page.
export function RequireRole({ roles, children }: { roles: Role[]; children: React.ReactNode }) {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <section className="adaptive-page">
        <LoadingState label="Checking your access…" />
      </section>
    );
  }

  if (status === 'guest' || !user) {
    const from = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/login" state={{ from }} replace />;
  }

  if (!roles.includes(user.role as Role)) {
    return <ErrorPage code={403} />;
  }

  return <>{children}</>;
}
